<template>
  <section class="container">
    <van-pull-refresh v-model="refresh_loading" @refresh="handleRefresh">
      <!-- style="height:100%;" -->
      <div class="modal_header">
        <div class="modal_header__title">月卡缴费</div>
        <div class="modal_header__info">¥{{ (queryData.money/100*carnum).toFixed(2) }}</div>
      </div>
      <div class="order_info">
        <van-cell title="车牌号码" :value="queryData.cardNumber" />
        <van-cell title="车场名称" :value="queryData.parkName " />
        <van-cell title="车位号码" :value="queryData.parkingNumber? queryData.parkingNumber:'未限定车位'" />
        <van-cell title="单月价格" :value="'¥' +(queryData.money/100).toFixed(2)" />
        <van-cell title="包月数量">
          <template #right-icon>
            <van-stepper v-model="carnum" min="1" />
          </template>
        </van-cell>
        <van-cell title="应缴金额" :value="'¥' + (queryData.money/100*carnum).toFixed(2)" />
        <van-cell value="银联支付">
          <template slot="title">
            <span class="custom-title">支付方式</span>
            <van-tag style="margin-left:5px;" type="danger">
              推荐
            </van-tag>
          </template>
        </van-cell>
      </div>
    </van-pull-refresh>
    <div class="btn_box bottom">

      <van-button :disabled="queryData.mone==0||carnum<1" @click="submit" size="large" class="blue-btn">
        缴费离场
      </van-button>
    </div>

  </section>
</template>

<script>
import { Stepper, Popup, CouponCell, CouponList, PullRefresh, CountDown, Tag, ActionSheet, Dialog } from 'vant'
import { YINLIAN_UnderOrderByMiddlewareCard } from '@/api/transaction'
import { setLocalStorage, getLocalStorage } from '@/utils/auth'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  props: {
    orders: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    [Stepper.name]: Stepper,
    [Popup.name]: Popup,
    [CouponCell.name]: CouponCell,
    [CouponList.name]: CouponList,
    [PullRefresh.name]: PullRefresh,
    [CountDown.name]: CountDown,
    [Tag.name]: Tag,
    [ActionSheet.name]: ActionSheet,
    [Dialog.Component.name]: Dialog.Component
  },
  computed: {

    ...mapGetters(['wx_userInfo', 'zfb_userInfo', 'token'])
  },

  data () {
    return {
      config,
      carnum: 1,
      queryData: {
        money: null,
        cardNumber: null,
        parkId: null,
        parkName: null,
        parkingNumber: null,
        platformId: null,
      },
      payWay: [], //支付渠道
      payWayChannel: null, //默认建行聚合支付
      refresh_loading: false,
      under_Order_Loading: null,
      showList: false,
      chosenCoupon: -1,
    }
  },
  mounted () {
    this.queryData = this.$route.query
    console.log(this.queryData)
  },
  methods: {
    // 银联支付
    Yinlian_UnderOrder_Submit () {
      let _this = this
      _this.under_Order_Loading = _this.$toast.loading('加载中...')
      let params = {
        cardNumber: this.queryData.cardNumber,
        chargeMoney: (this.queryData.money * this.carnum) / 100,
        // clientIp: 127.0.0.1,
        discountMoney: 0,
        goodsTag: this.queryData.cardNumber + '于' + this.queryData.parkName + '续费' + this.carnum + '个月',
        returnUrl: `https://${document.domain}/jn-pay-result`,
        monthlyTime: this.carnum,//包月时间
        notifyUrl: `${config.authBaseURL}/weChat/notifyUrlV2/api/YLMonthlyPackageCallback`,
        orderType: 21,//21续费 20新增
        paidMoney: this.queryData.money * this.carnum,
        parkId: this.queryData.parkId,
        parkName: this.queryData.parkName,
        parkingNumber: this.queryData.parkingNumber,
        platformId: this.queryData.platformId,
        remark: 1,//1停车场 2路边
        wxOpenid: _this.wx_userInfo ? _this.wx_userInfo.openid : _this.zfb_userInfo.userId,
        zfbUserid: ''
      }
      // let params = {
      //   parkId: _this.orders.parkId, //停车场Id,
      //   chargeId: _this.orders.id.toString(), //停车记录id
      //   cardNumber: _this.orders.cardNumber, //车牌号
      //   parking: _this.orders.parkDesc, //停车场名称
      //   paidMoney: (_this.payMoney * 100).toFixed(0),//实付金额 _this.payMoney
      //   paidTime: parseTime(new Date()),
      //   paymentScenario: "场内缴费",
      //   other3: 'JF',
      //   handleAmount: (_this.orders.chargeMoney).toString(), //应收金额
      //   discountAmount: (_this.orders.discount).toString(), //折扣金额
      // }
      YINLIAN_UnderOrderByMiddlewareCard(params).then(res => {
        _this.under_Order_Loading.clear()
        if (res.status === 1001) {
          window.location.href = window.unescape(res.body.billQRCode)
        } else {
          _this.$notify({
            type: 'danger',
            message: res.message
          })
        }
      }).catch(err => {
        _this.under_Order_Loading.clear()
        _this.$notify({
          type: 'danger',
          message: err
        })
      })
    },
    submit () {
      // 根据支付类型提交支付请求
      this.Yinlian_UnderOrder_Submit()
      // this.$store.dispatch('invoice/SetParkId', this.orders.parkId)
      // this.orders.outTradeNo = this.outTradeNo
      // this.$store.dispatch('invoice/SetPendingBill', [this.orders])
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  // min-height: calc(100% + 50px + 5vh); //基础高度 + 按键高度 + margin
  .modal_header {
    color: #444444;

    &__title {
      font-size: 18px;
      text-align: center;
      line-height: 24px;
      padding-top: 20px;
    }

    &__info {
      font-size: 42px;
      text-align: center;
      line-height: 80px;
      font-weight: bold;
      font-family: SourceHanSansCN-Bold;
    }

    &__countdown {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
    }
  }

  .bottom {
    margin: 20px auto 20px;
  }

  .btn_box {
    width: calc(100vw - 30px);
    max-width: 600px;
  }
}
</style>